export default {
  methods: {
    modifySelectorForProxy(selector) {
      return typeof selector === 'string'
        ? selector.replace(/(^|\s)a\b/ig, '$1span.anchor-to-span')
        : selector
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/Proxy.js